import { useMutation } from '@tanstack/react-query';

import { ActivityEndpoints } from '../../../../constants/endpoints/activityEndpoints.ts';
import { getAxios } from '../../../../lib/axios';
import { NewUnverifiedHotelModel } from '../addHotel/types';
import { HotelSearchResultCombined } from '../../../../features/activities/hotelSearch/types/hotelSearchResultCombined';

export function useNewUnverifiedHotelHotelSearchMutation() {
  return useMutation({
    mutationFn: async (vars: { activityId: number; model: NewUnverifiedHotelModel; forQuote: boolean }) => {
      const result = await getAxios().post<HotelSearchResultCombined>(
        ActivityEndpoints.hotelSearch.createUnverified(vars.activityId, vars.forQuote),
        vars.model
      );
      return result.data;
    }
  });
}
